import React from 'react';
import { PropTypes } from 'prop-types';

import styles from './imageCardCompact/imageCardCompact.module.scss';
import { CardImage } from './CardImage';
import { Skeleton } from './Skeleton';

export const ImageCardCompact = (props) => {
  let {
    className,
    title,
    imageSrc,
    noImageElement,
    size,
    duration,
    onClick,
    isSkeleton,
  } = props;

  let label = '';
  let value = '';

  if (isSkeleton) {
    title = <Skeleton style={{ width: '75%', height: `${14/16}rem` }} />;
    label = <Skeleton style={{ width: '66%', height: `${14/16}rem` }} />;
    value = <Skeleton style={{ width: '75%', height: `${14/16}rem` }} />;
  } else {
    if (size) {
      label = 'Size';
      value = size;
    } else if (duration) {
      label = 'Duration';
      value = duration;
    }
  }

  return (
    <div className={`${styles.container} ${className}`} onClick={onClick}>
      <div className={styles.image}>
        {!isSkeleton ? (
          <CardImage
            className={styles.cardImage}
            src={imageSrc}
            noImageElement={noImageElement}
          />
        ) : (
          <Skeleton style={{ width: '100%', height: '100%' }} />
        )}
      </div>
      <div className={styles.info}>
        <div className={styles.item}>
          <div className={styles.label}>
            {!isSkeleton ? 'Name' : (
              <Skeleton style={{ width: '66%', height: `${14/16}rem` }} />
            )}
          </div>
          <div className={styles.value}>
            {title}
          </div>
        </div>
        {!!label &&
          <div className={styles.item}>
            <div className={styles.label}>
              {label}
            </div>
            <div className={styles.value}>
              {value}
            </div>
          </div>
        }
      </div>
    </div>
  );
};

ImageCardCompact.propTypes = {
  className: PropTypes.string,
  imageSrc: PropTypes.string,
  noImageElement: PropTypes.element,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  size: PropTypes.string,
  duration: PropTypes.number,
  onClick: PropTypes.func,
};
